<template>
  <!-- 应用bottomcolor作为背景颜色，添加渐变效果 -->
  <div class="page-container" :style="{
    'color': textColor
  }" :class="{ 'has-bg-image': backgroundImageUrl }">
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
    <!-- 用户登录/信息区域 - 更现代化的设计 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>

        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item" @click="goToExchangeRecords">
              <el-icon>
                <Clock />
              </el-icon>
              <span>兑换记录</span>
            </div>

            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>

      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 - 玻璃拟态设计 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in shownNav" :key="item.path" :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path"
            :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容区域 - 卡片玻璃拟态效果 -->
    <div class="link-integral-container" :style="{ '--theme-color': settingData.color || '#ffffff' }">
      <el-card class="main-card glass-effect" shadow="hover" :style="{ 'background-color': cardBackgroundColor }">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Link />
            </el-icon>
            <span>{{ settingData.nickname }}的虚拟空间</span>
          </div>
        </template>

        <!-- 商品管理区域 -->
        <div class="shop-management">
          <!-- 顶部数据统计卡片 - 更现代化的设计 -->
          <div class="data-overview">
            <el-card shadow="hover" v-for="(stat, index) in stats" :key="index" class="stat-card glass-effect"
              :style="{ '--card-color': stat.color }">
              <div class="stat-content">
                <div class="stat-icon">
                  <el-icon :size="24">
                    <component :is="stat.icon" />
                  </el-icon>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ stat.value }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
            </el-card>
          </div>

          <!-- 搜索和操作区域 - 更紧凑的布局 -->
          <div class="action-area">
            <div class="action-bar">
              <el-input v-model="searchQuery" placeholder="输入商品名称或ID搜索" clearable class="search-input"
                @keyup.enter="handleSearch">
                <template #append>
                  <el-button :icon="Search" @click="handleSearch" />
                </template>
              </el-input>

              <div class="action-buttons">
                <el-tooltip content="刷新数据" placement="top">
                  <el-button :icon="Refresh" circle @click="getShopList" />
                </el-tooltip>
              </div>
            </div>

            <!-- 积分显示 - 更突出的设计 -->
            <div class="integral-display">
              <el-tag type="warning" effect="dark" size="large" class="integral-tag">
                <el-icon class="integral-icon">
                  <Coin />
                </el-icon>
                <span class="integral-text">你的积分: {{ settingData.Integral }} 积分</span>
              </el-tag>
            </div>
          </div>

          <!-- 手机端商品列表：一张张卡片（表格 8 列在手机上左右看不到头，
               主人要求「内容显示完整 + 功能没有异常」，所以小屏换成卡片） -->
          <div class="shop-mobile-list">
            <div v-if="!pagedTableData.length && !loading" class="shop-mobile-empty">暂无商品</div>
            <div class="shop-mobile-card" v-for="row in pagedTableData" :key="row.shopid">
              <div class="smc-head">
                <span class="smc-id">#{{ row.shopid }}</span>
                <el-tag :type="row.shopsale === '1' ? 'success' : 'danger'" effect="light" size="small">
                  {{ row.shopsale === '1' ? '可生产' : '不可生产' }}
                </el-tag>
              </div>
              <div class="smc-body">
                <div class="smc-img">
                  <el-image v-if="row.shopimg" :src="resolveImageUrl(row.shopimg)"
                    :preview-src-list="[resolveImageUrl(row.shopimg)]" fit="cover" class="smc-image"
                    :preview-teleported="true">
                    <template #error>
                      <div class="smc-no-img"><el-icon :size="20"><Picture /></el-icon></div>
                    </template>
                  </el-image>
                  <div v-else class="smc-no-img"><el-icon :size="20"><Picture /></el-icon></div>
                </div>
                <div class="smc-info">
                  <div class="smc-name">{{ row.shopname }}</div>
                  <div class="smc-meta">
                    <span class="smc-price">{{ row.shopprice }}<em>积分</em></span>
                    <span class="smc-time">制作 {{ row.shoptime }} 天</span>
                  </div>
                  <div class="smc-tags">
                    <el-tag v-if="isSoldOut(row)" type="danger" effect="dark" size="small">已售罄</el-tag>
                    <el-tag v-else-if="stockText(row)" type="warning" effect="plain" size="small">{{ stockText(row) }}</el-tag>
                    <el-tag v-else type="success" effect="plain" size="small">库存充足</el-tag>
                    <el-tag :type="row.virtual === '1' ? 'primary' : 'success'" size="small" effect="plain">
                      {{ row.virtual === '1' ? '电子礼物' : '实物' }}
                    </el-tag>
                  </div>
                </div>
              </div>
              <div class="smc-foot">
                <el-button type="primary" size="small" :icon="Search" @click="openDetail(row)">详情</el-button>
                <el-button type="success" size="small" :icon="Star" @click="Exchange(row)"
                  :disabled="!isExchangeEnabled || isSoldOut(row)">兑换</el-button>
              </div>
            </div>
          </div>

          <!-- 商品表格 - 更精致的样式（电脑端） -->
          <div class="shop-table-container">
            <el-table :data="pagedTableData" border stripe :loading="loading" style="width: 100%"
              class="custom-table" v-loading="loading">
              <el-table-column prop="shopid" label="商品ID" align="center" />
              <el-table-column prop="shopname" label="商品名称" min-width="100" show-overflow-tooltip>
                <template #default="{ row }">
                  <span class="shop-name">{{ row.shopname }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="shopprice" label="价格" width="110" align="right">
                <template #default="{ row }">
                  <div class="price-cell">
                    <span class="price-value">{{ row.shopprice }}</span>
                    <el-tag size="small" type="warning" effect="plain" class="price-tag">积分</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="shoptime" label="制作周期" width="110" align="center">
                <template #default="{ row }">
                  <div class="time-cell">
                    <span class="time-value">{{ row.shoptime }}</span>
                    <el-tag size="small" effect="plain" class="time-tag">天</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="shopsale" label="状态" width="110" align="center">
                <template #default="{ row }">
                  <el-tag :type="row.shopsale === '1' ? 'success' : 'danger'" effect="light"
                    :class="{ 'pulse': row.shopsale === '1' }">
                    {{ row.shopsale === '1' ? '可生产' : '不可生产' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="库存" width="110" align="center">
                <template #default="{ row }">
                  <el-tag v-if="isSoldOut(row)" type="danger" effect="dark" size="small">已售罄</el-tag>
                  <el-tag v-else-if="stockText(row)" type="warning" effect="plain" size="small">{{ stockText(row) }}</el-tag>
                  <el-tag v-else type="success" effect="plain" size="small">充足</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="virtual" label="类型" width="90" align="center">
                <template #default="{ row }">
                  <el-tag :type="row.virtual === '1' ? 'primary' : 'success'" size="small">
                    {{ row.virtual === '1' ? '电子礼物' : '实物' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="商品图片" width="140" align="center">
                <template #default="{ row }">
                  <div class="product-image-container">
                    <el-image v-if="row.shopimg" :src="resolveImageUrl(row.shopimg)"
                      :preview-src-list="[resolveImageUrl(row.shopimg)]" fit="cover" class="product-image" :zoom-rate="1.2"
                      :preview-teleported="true">
                      <template #error>
                        <div class="image-error">
                          <el-icon :size="24">
                            <Picture />
                          </el-icon>
                        </div>
                      </template>
                    </el-image>
                    <div v-else class="no-image">
                      <el-icon :size="24">
                        <Picture />
                      </el-icon>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="130" align="center">
                <template #default="{ row }">
                  <el-tooltip content="详情" placement="top">
                    <el-button type="primary" :icon="Search" circle size="small" @click="openDetail(row)" />
                  </el-tooltip>
                  <el-tooltip :content="isSoldOut(row) ? '已售罄' : '兑换'" placement="top">
                    <el-button type="success" :icon="Star" circle size="small" @click="Exchange(row)"
                      :disabled="!isExchangeEnabled || isSoldOut(row)" />
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页组件 - 更协调的设计 -->
          <div class="pagination-container">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper"
              :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
              :total="pagination.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>

          <!-- 详情弹窗 - 更丰富的展示 -->
          <el-dialog v-model="detailVisible" title="商品详情" width="650px" custom-class="detail-dialog"
            :close-on-click-modal="false">
            <div class="detail-content">
              <div class="image-section">
                <el-image v-if="currentShop.shopimg" :src="resolveImageUrl(currentShop.shopimg)" fit="cover"
                  class="detail-image" :preview-src-list="[resolveImageUrl(currentShop.shopimg)]" />
                <div v-else class="detail-no-image">
                  <el-icon :size="48">
                    <Picture />
                  </el-icon>
                  <p>暂无商品图片</p>
                </div>
              </div>
              <div class="info-section">
                <div class="info-row">
                  <span class="info-label">商品ID：</span>
                  <span class="info-value">{{ currentShop.shopid }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">商品名称：</span>
                  <span class="info-value shop-name">{{ currentShop.shopname }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">积分价格：</span>
                  <span class="info-value price">{{ currentShop.shopprice }}
                    <el-tag size="small" type="warning" effect="plain">积分</el-tag>
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">制作周期：</span>
                  <span class="info-value">{{ currentShop.shoptime }}
                    <el-tag size="small" effect="plain">天</el-tag>
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">状态：</span>
                  <el-tag :type="currentShop.shopsale === '1' ? 'success' : 'danger'" effect="light" size="medium"
                    class="status-tag">
                    {{ currentShop.shopsale === '1' ? '可生产' : '不可生产' }}
                  </el-tag>
                </div>
                <div class="info-row">
                  <span class="info-label">库存：</span>
                  <el-tag v-if="isSoldOut(currentShop)" type="danger" effect="dark" size="small">已售罄</el-tag>
                  <el-tag v-else-if="stockText(currentShop)" type="warning" effect="plain" size="small">{{ stockText(currentShop) }}</el-tag>
                  <el-tag v-else type="success" effect="plain" size="small">库存充足</el-tag>
                </div>
                <div class="info-row" v-if="currentShop.description">
                  <span class="info-label">商品描述：</span>
                  <span class="info-value description">{{ currentShop.description }}</span>
                </div>
              </div>
            </div>
            <template #footer>
              <el-button type="primary" @click="detailVisible = false" class="dialog-close-btn">
                关 闭
              </el-button>
            </template>
          </el-dialog>
        </div>
      </el-card>
    </div>

    <!-- 兑换确认对话框 -->
    <el-dialog v-model="exchangeDialogVisible" title="兑换确认" width="500px">
      <el-form :model="exchangeForm" :rules="exchangeRules" ref="exchangeFormRef">
        <el-form-item label="商品名称" prop="shopName">
          <el-input v-model="exchangeForm.shopName" disabled />
        </el-form-item>
        <el-form-item label="所需积分" prop="shopPrice">
          <el-input v-model="exchangeForm.shopPrice" disabled />
        </el-form-item>
        <!-- 虚拟礼物提示 -->
        <el-alert v-if="exchangeForm.isVirtual === '1'" 
          title="电子礼物提示" type="info" :closable="false" show-icon style="margin-bottom: 16px;">
          <template #default>
            <p>这是电子礼物，不需要填写收货信息。</p>
            <p>每个电子礼物最多可下载 <strong>5次</strong>，请妥善保存。</p>
          </template>
        </el-alert>
        <!-- 实物礼物才显示收货信息 -->
        <template v-if="exchangeForm.isVirtual !== '1'">
          <el-form-item label="收货人" prop="receiver">
            <el-input v-model="exchangeForm.receiver" placeholder="请输入收货人姓名" />
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="exchangeForm.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="收货地址" prop="address">
            <el-input 
              v-model="exchangeForm.address" 
              type="textarea" 
              :rows="3" 
              placeholder="请输入详细收货地址"
            />
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button @click="exchangeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExchange">确认兑换</el-button>
      </template>
    </el-dialog>

    <div class="floating-button-container">
      <el-tooltip content="反馈" placement="left">
        <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }"
          @click="handleClick">
          <el-icon size="30">
            <Service />
          </el-icon>
        </el-button>
      </el-tooltip>
    </div>

    <!-- 反馈表单对话框 -->
    <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog"
      :close-on-click-modal="false">
      <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
        <el-form-item label="你的B站UID" prop="userId">
          <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
        </el-form-item>

        <el-form-item label="问题类型" prop="problemType">
          <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
            <el-option label="加群审核" value="加群审核"></el-option>
            <el-option label="禁言申诉" value="禁言申诉"></el-option>
            <el-option label="私信补发" value="私信补发"></el-option>
            <el-option label="音声礼物" value="音声礼物"></el-option>
            <el-option label="物流相关" value="物流相关"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="问题描述" prop="problemDesc">
          <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
        </el-form-item>

        <el-form-item label="QQ联系方式" prop="contactInfo">
          <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="floatingVisible = false">取消</el-button>
          <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 在template部分的最后，floating-button-container之后添加备案号 -->
    <div class="footer-record">
      <div class="record-text" :style="{ 'color': textColor }">
        <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
          陕ICP备2025066285号-2
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Link, Search, Refresh, User, StarFilled, SwitchButton, Service, Star,
  Coin, Picture, HomeFilled, Calendar, Collection, Clock,
  Present, Headset, InfoFilled
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';
import { resolveImageUrl } from '../../util/imageUrl';

const route = useRoute();
const router = useRouter();
const isExchangeEnabled = ref(true);

// 导航项配置
const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: 'Calendar' },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});

// 判断当前路由是否激活
const isActive = (path) => {
  return route.path === path;
};

const goToExchangeRecords = () => {
  showDropdown.value = false;
  router.push('/exchange-records');
};

const logout2 = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage.success('已退出登录');
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 计算文本颜色基于背景色
const textColor = computed(() => {
  const bgColor = settingData.bottomcolor || '#000000';
  // 简单计算背景亮度决定文字颜色
  const color = bgColor.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
});

// 计算卡片背景颜色
const cardBackgroundColor = computed(() => {
  const bgColor = settingData.backcolor || 'rgba(255, 255, 255, 0.9)';
  if (bgColor.includes('rgba')) {
    // 如果是rgba，增加透明度
    return bgColor.replace(/[\d\.]+\)$/, '0.85)');
  }
  return bgColor;
});

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
  uname: '',
  mid: '',
  face: ''
});
const showDropdown = ref(false);

// 点击空白处关闭下拉菜单
const handleClickOutside = (event) => {
  const userArea = document.querySelector('.user-area');
  if (userArea && !userArea.contains(event.target)) {
    showDropdown.value = false;
  }
};

// 检查登录状态
const checkLoginStatus = () => {
  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    try {
      const parsedInfo = JSON.parse(savedUserInfo);
      if (parsedInfo.mid) {
        Object.assign(userInfo, parsedInfo);
        isLoggedIn.value = true;
      }
    } catch (e) {
      console.error('解析用户信息失败:', e);
      localStorage.removeItem('userInfo');
    }
  }
};

// 登录跳转
const goToLogin = () => {
  router.push('/user/login');
};

// 退出登录
const logout = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    settingData.Integral = '(请前往登录查看)';
    ElMessage({
      message: '请前往登录使用该功能',
      type: 'warning',
      offset: 20,
      duration: 3000,
      customClass: 'slide-in-left-message'
    });

  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 获取用户积分
const UserIntegral = async (usermid) => {
  try {
    const response = await axios.post('/adminapi/userapi/integral/check', {
      uid: usermid
    });
    settingData.Integral = response.data.results[0]?.integral || 0;
  } catch (error) {
    console.error('查询积分失败:', error);
    settingData.Integral = 0;
  }
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await axios.get('/adminapi/user/Bmsg', {
      withCredentials: true
    });

    if (response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      userInfo.uname = userData.uname || '';
      userInfo.mid = userData.mid || '';
      userInfo.face = await setBilibiliAvatar(userData.face);
      isLoggedIn.value = true;
      UserIntegral(userInfo.mid);

      localStorage.setItem('userInfo', JSON.stringify({
        uname: userInfo.uname,
        mid: userInfo.mid,
        face: userInfo.face
      }));
    } else {
      console.error("获取用户信息失败:", response.data.message);
      logout();
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
    logout();
  }
};

const setBilibiliAvatar = async (str) => {
  try {
    const response = await axios.post('/adminapi/user/avater', {
      face: str,
    }, {
      responseType: 'arraybuffer',
      withCredentials: true
    });

    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('获取头像失败:', error);
    return '/default-avatar.png';
  }
}

// 表单数据
const urlForm = reactive({
  Live_streaming_room: '',
  Home_Page: '',
  afd: ''
});

// 主播信息数据
const settingData = reactive({
  nickname: '',
  slogan: '',
  homepageImage: '',
  color: '#ffffff',
  backcolor: 'rgba(255, 255, 255, 0.85)',
  Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  bottomcolor: '#000000',
  Integral: 0
});

// 商品管理数据
const tableData = ref([]);
const filteredTableData = ref([]);
const loading = ref(false);
const detailVisible = ref(false);
const currentShop = reactive({});
const searchQuery = ref('');
const pagination = reactive({
  current: 1,
  size: 10,
  total: 0
});

// 统计数据
const stats = ref([
  { icon: 'Collection', value: '0', label: '商品总数', color: '#FF6B6B' },
  { icon: 'CircleCheckFilled', value: '0', label: '可生产商品', color: '#4ECDC4' }
]);

// 背景图片URL
const backgroundImageUrl = ref('');

// 兑换相关数据
const exchangeDialogVisible = ref(false);
const exchangeFormRef = ref(null);
const currentExchangeItem = ref(null);

const exchangeForm = reactive({
  shopName: '',
  shopPrice: '',
  receiver: '',
  phone: '',
  address: '',
  isVirtual: '0'
});

const exchangeRules = reactive({
  receiver: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  address: [{ required: true, message: '请输入收货地址', trigger: 'blur' }]
});

// 获取链接数据和主播信息
const fetchData = async () => {
  try {
    const [urlResponse, settingResponse] = await Promise.all([
      axios.get('/adminapi/userapi/url/list'),
      axios.get('/adminapi/setting/list')
    ]);

    const urlData = urlResponse.data.results[0] || {};
    const settingDataRes = settingResponse.data.results[0] || {};

    urlForm.Live_streaming_room = urlData.Live_streaming_room || '';
    urlForm.Home_Page = urlData.Home_Page || '';
    urlForm.afd = urlData.afd || '';

    settingData.nickname = settingDataRes.title || '塔娅娅';
    settingData.slogan = settingDataRes.content || '只是想成为一个可爱的虚拟小地偶';
    settingData.homepageImage = settingDataRes.homepageImage || '';
    settingData.color = settingDataRes.color || '#ffffff';
    settingData.backcolor = settingDataRes.backcolor || 'rgba(255, 255, 255, 0.85)';
    settingData.Navigationcolor = settingDataRes.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
    settingData.bottomcolor = settingDataRes.bottomcolor || '#000000';
    const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
    backgroundImageUrl.value = settingDataRes.page ? ASSET_BASE + settingDataRes.page : defaultBackground;
  } catch (error) {
    console.error('加载数据错误:', error);
  }
};

// 获取商品列表
const getShopList = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/adminapi/shop/list');
    tableData.value = response.data.results || [];
    filteredTableData.value = response.data.results;
    pagination.total = tableData.value.length;
    pagination.current = 1; // 重新拉取后回到第一页，避免停在越界页码显示空白
    updateStats(tableData.value);
  } catch (error) {
    console.error('获取商品列表失败:', error);
    ElMessage.error('网络请求失败，请重试');
  } finally {
    loading.value = false;
  }
};

// 更新统计数据
const updateStats = (data) => {
  if (!data || data.length === 0) {
    stats.value = [
      { icon: 'Collection', value: '0', label: '商品总数', color: '#FF6B6B' },
      { icon: 'CircleCheckFilled', value: '0', label: '可生产商品', color: '#4ECDC4' }
    ];
    return;
  }

  const totalCount = data.length;
  const producibleCount = data.filter(item => item.shopsale === '1').length;

  stats.value = [
    { icon: 'Collection', value: totalCount.toString(), label: '商品总数', color: '#FF6B6B' },
    { icon: 'CircleCheckFilled', value: producibleCount.toString(), label: '可生产商品', color: '#4ECDC4' }
  ];
};

// 打开详情弹窗
const openDetail = (row) => {
  Object.assign(currentShop, row);
  detailVisible.value = true;
};

// ---------- 库存展示 ----------
// 后台可能只下发 stockSoldOut（不暴露真实库存数字），也可能带 stock（后台/管理员视角）
const isSoldOut = (row) => {
  if (!row) return false;
  if (row.stockSoldOut === true) return true;
  const stock = Number(row.stock);
  return row.stock !== undefined && row.stock !== null && row.stock !== '' && !Number.isNaN(stock) && stock >= 0 && stock <= 0;
};

// 剩余 1-5 件时给个「仅剩 N 件」的提示，其它情况返回空串
const stockText = (row) => {
  const stock = Number(row && row.stock);
  if (!row || row.stock === undefined || row.stock === null || row.stock === '') return '';
  if (Number.isNaN(stock) || stock < 0 || stock > 5) return '';
  return stock > 0 ? `仅剩 ${stock} 件` : '';
};

// 商品兑换
const Exchange = async (row) => {
  if (!row.shopname || userInfo.uname === '' || userInfo.mid === '' || settingData.Integral === "(请前往登录查看)") {
    ElMessage.error('请先登录');
    return;
  }
  
  if(row.shopsale === '0') {
    ElMessage.error('不可生产');
    return;
  }

  if (isSoldOut(row)) {
    ElMessage.error('该商品已售罄');
    return;
  }
  
  if (Number(settingData.Integral) < Number(row.shopprice)) {
    ElMessage.error('积分不足');
    return;
  }
  
  // 保存当前兑换商品
  currentExchangeItem.value = row;
  
  // 填充表单数据
  exchangeForm.shopName = row.shopname;
  exchangeForm.shopPrice = row.shopprice;
  exchangeForm.isVirtual = row.virtual || '0';
  exchangeForm.receiver = '';
  exchangeForm.phone = '';
  exchangeForm.address = '';
  
  // 打开对话框
  exchangeDialogVisible.value = true;
};

// 确认兑换
const confirmExchange = async () => {
  try {
    // 虚拟礼物跳过收货信息验证
    if (exchangeForm.isVirtual !== '1') {
      await exchangeFormRef.value.validate();
    }
    
    isExchangeEnabled.value = false;
    
    const isVirtual = exchangeForm.isVirtual || '0';
    const ExchangeDate = {
      id: generateId(),
      uid: userInfo.mid,
      name: userInfo.uname,
      time: formatTime(Date.now()),
      shop: currentExchangeItem.value.shopname,
      received: isVirtual === '1' ? '电子礼物' : exchangeForm.receiver,
      receivedph: isVirtual === '1' ? '' : exchangeForm.phone,
      receivedurl: isVirtual === '1' ? '' : exchangeForm.address,
      virtual: isVirtual,
      shopid: currentExchangeItem.value.shopid || '',
      shopprice: currentExchangeItem.value.shopprice || '0',
      recordId: generateId()
    };
    
    // 扣分与建单统一由后端处理（服务端校验余额、以库里价格为准），前端不再自行扣分
    const response = await axios.post("/adminapi/user/Exchange/add", ExchangeDate);
    
    if (response.data && response.data.code === 200) {
      ElMessage.success('兑换成功' + (isVirtual === '1' ? '，电子礼物可在兑换记录中下载（限5次）' : ''));
      exchangeDialogVisible.value = false;
      // 用后端返回的真实价格刷新积分显示
      const paid = Number(response.data.data?.price ?? currentExchangeItem.value.shopprice) || 0;
      settingData.Integral = Number(settingData.Integral) - paid;
    } else {
      ElMessage.error(response.data?.message || '兑换失败，请重试');
      // 售罄类失败要立刻刷新列表，把「已售罄」状态同步出来
      if (response.data?.data?.soldOut) {
        exchangeDialogVisible.value = false;
        getShopList();
      }
    }
  } catch (error) {
    console.error('兑换失败:', error);
    ElMessage.error('兑换失败，请重试');
  } finally {
    isExchangeEnabled.value = true;
  }
};

// 表格真正渲染的数据：原来直接绑 filteredTableData（全量），分页器点了没反应，这里按页切片
const pagedTableData = computed(() => {
  const start = (pagination.current - 1) * pagination.size;
  return filteredTableData.value.slice(start, start + pagination.size);
});

// 搜索处理
const handleSearch = () => {
  pagination.current = 1;
  if (!searchQuery.value.trim()) {
    filteredTableData.value = [...tableData.value];
    return;
  }

  const query = searchQuery.value.toLowerCase();
  filteredTableData.value = tableData.value.filter(
    item =>
      String(item.shopid).includes(query) ||
      item.shopname.toLowerCase().includes(query)
  );
  ElMessage.success(`找到 ${filteredTableData.value.length} 条结果`);
};

// 分页处理
const handleSizeChange = (val) => {
  pagination.size = val;
  pagination.current = 1;
};

const handleCurrentChange = (val) => {
  pagination.current = val;
};

// 点击事件处理
const floatingVisible = ref(false);
// 反馈表单数据
const feedbackForm = reactive({
  userId: '',
  problemType: '',
  problemDesc: '',
  contactInfo: '',
  time: '',
  Solve: '未解决',
  id: ''
});

const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  var nameid = `${timestamp}${random}`
  return nameid
}

const feedbackFormRef = ref(null);
const feedbackRules = reactive({
  userId: [{ required: true, message: '请输入你的B站UID', trigger: 'blur' }],
  problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
  problemDesc: [{ required: true, message: '请描述你的问题', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
});

const handleClick = () => {
  console.log('反馈按钮被点击')
  floatingVisible.value = true
}

const submitFeedback = async () => {
    // 表单声明了 :rules 却从不校验，空字段会直接写进 Feedback 表
    if (!feedbackFormRef.value) return;
    try {
        await feedbackFormRef.value.validate();
    } catch (e) {
        return; // 校验不通过，Element Plus 已在字段下方给出提示
    }
  feedbackForm.time = formatTime(Date.now())
  feedbackForm.id = generateId()
  try {
    var response = await axios.post('/adminapi/Feedback/add', feedbackForm)
    if (response.data && response.data.code === 200) {
      floatingVisible.value = false
      ElMessage.success('反馈成功');
      resetFeedbackForm()
    } else {
      floatingVisible.value = false
      ElMessage.error((response.data && response.data.message) || '反馈失败');
    }
  } catch (error) {
    console.error('反馈提交失败:', error)
    floatingVisible.value = false
    ElMessage.error('反馈失败，请稍后重试');
  }
}

const formatTime = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
};

const resetFeedbackForm = () => {
  feedbackForm.userId = '';
  feedbackForm.problemType = '';
  feedbackForm.problemDesc = '';
  feedbackForm.contactInfo = '';
  feedbackForm.time = '';
  feedbackForm.Solve = '未解决';
  feedbackForm.id = '';
};

// 监听表格数据变化，更新统计数据
watch(tableData, (newData) => {
  updateStats(newData);
}, { deep: true });

// 搜索后 total 要跟着结果集走，否则分页器显示的是全量条数
watch(filteredTableData, (list) => {
  pagination.total = list.length;
  const maxPage = Math.max(1, Math.ceil(list.length / pagination.size));
  if (pagination.current > maxPage) pagination.current = maxPage;
});

onMounted(() => {
  checkLoginStatus();
  fetchUserInfo();
  fetchData();
  getShopList();

  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
/* 基础样式 */
:root {
  --glass-blur: 8px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: none !important;
  /* 移除任何背景设置 */
}

.page-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
  /* 使用CSS变量动态设置背景图片 */
  background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}

.page-container.has-bg-image {
  background-image: url('');
  /* 这里通过JS动态设置 */
}

/* 用户区域样式 - 更现代化的设计 */
.user-area {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;

  .user-info-box {
    position: relative;

    .user-avatar-wrapper {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);

        .user-badge {
          transform: translate(30%, -30%) scale(1.2);
        }
      }

      .user-avatar {
        border: 2px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .user-badge {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #ff4081, #7b1fa2);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        transform: translate(30%, -30%);
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        z-index: 1;

        .el-icon {
          width: 12px;
          height: 12px;
        }
      }
    }

    .user-dropdown-menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 260px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      z-index: 200;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      .dropdown-header {
        padding: 20px;
        display: flex;
        background: linear-gradient(135deg, rgba(245, 247, 250, 0.8), rgba(228, 231, 235, 0.8));
        border-bottom: 1px solid rgba(238, 238, 238, 0.5);

        .dropdown-avatar {
          margin-right: 15px;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;

          h3 {
            margin: 0 0 5px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
          }

          .user-id {
            margin: 0;
            color: #666;
            font-size: 12px;
          }

          .user-integral {
            margin: 5px 0 0;
            color: #e6a23c;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .dropdown-divider {
        height: 1px;
        background: rgba(238, 238, 238, 0.5);
        margin: 0 15px;
      }

      .dropdown-item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(245, 247, 250, 0.8);
          color: #ff4081;

          .el-icon {
            color: #ff4081;
          }
        }

        .el-icon {
          margin-right: 10px;
          font-size: 16px;
          color: #777;
          transition: color 0.2s ease;
        }
      }
    }
  }
}

.login-entry {
  .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);

      .el-icon {
        transform: translateX(3px);
      }
    }

    .el-icon {
      transition: transform 0.3s ease;
    }
  }
}

/* 导航栏样式 - 玻璃拟态设计 */
.navbar {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  backdrop-filter: blur(var(--glass-blur));

  .nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    a {
      color: white;
      text-decoration: none;
      font-size: 15px;
      padding: 10px 18px;
      border-radius: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }

      &.router-link-active {
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        font-weight: bold;
      }

      .nav-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 玻璃拟态效果 */
.glass-effect {
  backdrop-filter: blur(var(--glass-blur));
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

.link-integral-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;

  .main-card {
    border-radius: 16px !important;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .header-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: var(--theme-color);
    padding: 10px 0;

    .title-icon {
      margin-right: 10px;
      color: var(--theme-color);
      font-size: 20px;
    }
  }
}

/* 商品管理区域样式 */
.shop-management {
  padding: 20px;

  .data-overview {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
    margin-bottom: 24px;

    .stat-card {
      border-radius: 12px !important;
      transition: all 0.3s ease;
      overflow: hidden;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.05));
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
      }
    }

    .stat-content {
      display: flex;
      align-items: center;
      padding: 16px;
      position: relative;
      z-index: 1;
    }

    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 22px;
      margin-right: 15px;
      background: var(--card-color);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

      .el-icon {
        font-size: 24px;
      }
    }

    .stat-value {
      font-size: 24px;
      font-weight: bold;
      color: 2d3748;
      line-height: 1.2;
    }

    .stat-label {
      font-size: 14px;
      color: #718096;
    }
  }

  .action-area {
    margin-bottom: 20px;
  }

  .action-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    gap: 15px;
    flex-wrap: wrap;

    .search-input {
      flex: 1;
      min-width: 250px;
      max-width: 400px;

      :deep(.el-input-group__append) {
        background-color: var(--theme-color);
        color: white;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        transition: all 0.3s ease;

        &:hover {
          background-color: lighten(#409EFF, 10%);
        }
      }
    }

    .action-buttons {
      display: flex;
      gap: 10px;

      .el-button {
        transition: all 0.3s ease;

        &:hover {
          transform: rotate(15deg);
        }
      }
    }
  }

  .integral-display {
    margin-bottom: 20px;

    .integral-tag {
      padding: 8px 15px;
      font-size: 15px;
      font-weight: bold;
      border-radius: 20px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

      .integral-icon {
        margin-right: 8px;
      }

      .integral-text {
        vertical-align: middle;
      }
    }
  }

  .shop-table-container {
    margin-bottom: 20px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .custom-table {
      --el-table-border-color: rgba(0, 0, 0, 0.08);
      --el-table-header-bg-color: #f8fafc;
      --el-table-row-hover-bg-color: #f5f7fa;

      th {
        font-weight: 600;
        background-color: var(--el-table-header-bg-color) !important;
      }

      .shop-name {
        font-weight: 500;
      }

      .price-cell {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .price-value {
          margin-right: 5px;
          font-weight: 500;
        }

        .price-tag {
          margin-left: 3px;
        }
      }

      .time-cell {
        display: flex;
        align-items: center;
        justify-content: center;

        .time-value {
          margin-right: 5px;
        }
      }

      .product-image-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .product-image {
        width: 80px;
        height: 60px;
        border-radius: 6px;
        display: block;
        cursor: pointer;
        transition: transform 0.3s ease;
        object-fit: cover;

        &:hover {
          transform: scale(1.03);
        }
      }

      .no-image,
      .image-error {
        width: 80px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f7fa;
        border-radius: 6px;
        color: #c0c4cc;
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    padding: 15px 0;

    .el-pagination {

      :deep(.btn-prev),
      :deep(.btn-next),
      :deep(.number) {
        border-radius: 8px !important;
        margin: 0 3px;
      }
    }
  }

  /* 详情弹窗样式 */
  .detail-dialog {
    border-radius: 16px !important;

    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-right: 0;
    }

    .el-dialog__title {
      font-weight: 600;
      color: #333;
    }

    .detail-content {
      margin-top: 20px;
      display: flex;
      gap: 25px;

      .image-section {
        flex: 0 0 220px;

        .detail-image {
          width: 100%;
          height: 220px;
          margin-left: 30px;
          border-radius: 12px;
          object-fit: cover;
          border: 1px solid #ebeef5;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .detail-no-image {
          width: 100%;
          height: 220px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #f5f7fa;
          border-radius: 12px;
          border: 1px dashed #dcdfe6;
          color: #909399;

          .el-icon {
            color: #c0c4cc;
          }

          p {
            margin-top: 10px;
            font-size: 14px;
            color: #909399;
          }
        }
      }

      .info-section {
        flex: 1;

        .info-row {
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          min-height: 28px;
        }

        .info-label {
          font-weight: 600;
          color: #606266;
          width: 90px;
          text-align: right;
          flex-shrink: 0;
        }

        .info-value {
          color: #303133;
          flex: 1;
          padding-left: 12px;
          word-break: break-word;
        }

        .shop-name {
          font-weight: 500;
          font-size: 16px;
        }

        .price {
          color: #e6a23c;
          font-weight: bold;
          display: inline-flex;
          align-items: center;

          .el-tag {
            margin-left: 8px;
          }
        }

        .description {
          line-height: 1.6;
          color: #606266;
        }

        .status-tag {
          font-weight: bold;
          padding: 6px 12px;
        }
      }
    }

    .dialog-close-btn {
      padding: 10px 20px;
      border-radius: 8px;
      font-weight: 500;
    }
  }
}

.pulse {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(103, 194, 58, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0);
  }
}

/* 手机端商品卡片：电脑端隐藏。必须放在所有 @media 之前——
   同一个选择器同样优先级时后写的规则会赢，这条写在后面会把手机端
   @media 里的 display:block 盖掉（踩过一次，记下来） */
.shop-mobile-list { display: none; }

/* 响应式调整 */
@media (max-width: 992px) {
  .action-bar {
    flex-direction: column;

    .search-input {
      max-width: 100%;
    }
  }

  .detail-content {
    flex-direction: column !important;

    .image-section {
      margin-bottom: 20px;
    }
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }

  .user-area {
    top: 15px;
    right: 15px;

    .user-info-box .user-dropdown-menu {
      width: 240px;
    }
  }

  .navbar {
    margin-bottom: 20px;

    .nav-list {
      gap: 8px;
    }

    .nav-item a {
      padding: 8px 15px;
      font-size: 14px;
    }
  }

  .data-overview {
    grid-template-columns: 1fr 1fr !important;
  }

  .shop-management {
    padding: 15px;
  }

  /* 手机上不等宽的表格改成卡片显示，表格本身收起（电脑端不变） */
  .shop-mobile-list { display: block; }

  .shop-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* 电脑端表格还留着，手机端隐藏（下面的 .el-table 规则对手机无效但不影响桌面） */
  }

  /* 手机端工具栏：搜索框占满整行，别都被撑出卡片 */
  .action-bar .search-input { min-width: 0 !important; max-width: 100% !important; flex: 1 1 100% !important; }
  .action-bar .action-buttons { width: 100%; justify-content: flex-end; }

  /* 分页：手机上只留页码和上一页/下一页，避免被裁 */
  .pagination-container { margin-top: 14px; overflow-x: auto; }
  .pagination-container .el-pagination { justify-content: center; flex-wrap: wrap; row-gap: 8px; }
  .pagination-container .el-pagination__total,
  .pagination-container .el-pagination__jump { display: none !important; }

  /* 电脑端那张宽表格，手机端收起来并允许左右滑（display:block 才会真的出横向滚动条） */
  .shop-table-container { display: none; }

  .el-table {
    display: block;
    min-width: 700px;
    overflow-x: auto;
  }
}

/* ---------- 手机端商品卡片（电脑端隐藏，规则见文件前面的基础声明） ---------- */
.shop-mobile-card {
  border: 1px solid rgba(0, 0, 0, .08);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, .72);
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);

  .smc-head {
    display: flex; align-items: center; justify-content: space-between;
    padding-bottom: 8px; border-bottom: 1px dashed rgba(0, 0, 0, .08);
  }

  .smc-id { font-size: 12px; color: #909399; font-weight: 600; }

  .smc-body { display: flex; gap: 12px; padding: 10px 0; }

  .smc-img { width: 84px; height: 84px; flex-shrink: 0; }

  .smc-image, .smc-no-img {
    width: 84px; height: 84px; border-radius: 10px; overflow: hidden; display: block;
  }

  .smc-no-img {
    display: flex; align-items: center; justify-content: center;
    background: #f5f7fa; color: #c0c4cc;
  }

  .smc-info { flex: 1; min-width: 0; }

  .smc-name {
    font-size: 15px; font-weight: 600; color: #303133; line-height: 1.4;
    word-break: break-word; margin-bottom: 6px;
  }

  .smc-meta { display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; margin-bottom: 8px; }

  .smc-price {
    font-size: 16px; font-weight: 700; color: #e6a23c;

    em { font-style: normal; font-size: 12px; margin-left: 2px; font-weight: 400; }
  }

  .smc-time { font-size: 12px; color: #909399; }

  .smc-tags { display: flex; gap: 6px; flex-wrap: wrap; }

  .smc-foot {
    display: flex; justify-content: flex-end; gap: 8px;

    /* 手指点得准一点：小按钮在手机上撑到 34 高 */
    .el-button { height: 34px; padding: 0 14px; font-size: 13px; }
  }
}

.shop-mobile-empty { text-align: center; color: #909399; padding: 24px 0; font-size: 14px; }

@media (max-width: 480px) {
  .user-area {
    .login-entry .login-button {
      padding: 6px 15px;
      font-size: 13px;
    }

    .user-info-box .user-dropdown-menu {
      width: 220px;
    }
  }

  .navbar .nav-item a {
    padding: 6px 12px;
    font-size: 13px;

    .nav-icon {
      margin-right: 5px;
    }
  }

  .data-overview {
    grid-template-columns: 1fr !important;
  }

  .integral-tag {
    font-size: 14px !important;
    padding: 6px 12px !important;
  }
}

.floating-button-container {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-button {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #409EFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 56px;
  height: 56px;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }
}

.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: -1;
  /* 确保在内容层下方 */
  // filter: brightness(0.7);
  /* 适当降低亮度增加可读性 */

  /* 如果需要覆盖渐变效果 */

}
/* 在style部分添加备案号样式 */
.footer-record {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  padding: 8px 0;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.2);
  
  .record-text {
    font-size: 12px;
    letter-spacing: 0.5px;
    
    a {
      text-decoration: none;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
}

/* 自定义消息提示动画 - 从左往右滑入 */
:deep(.slide-in-left-message) {
  animation: slideInFromLeft 0.4s ease-out;
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>


<style>
/* 全局样式 - 自定义消息提示位置和动画 */
.slide-in-left-message {
  left: 6% !important;
  right: auto !important;
  animation: slideInFromLeft 0.4s ease-out !important;
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
